import { render, staticRenderFns } from "./CardSpotlight.vue?vue&type=template&id=d82dde44&scoped=true&"
import script from "./CardSpotlight.vue?vue&type=script&lang=js&"
export * from "./CardSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./CardSpotlight.vue?vue&type=style&index=0&id=d82dde44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82dde44",
  null
  
)

export default component.exports